import React, { Component, useEffect, useReducer, useState } from "react"
import DataCenter, { Connections, CurrentCurrency } from "../modules/DataCenter";
import API from "../conf/API";
import { GetOrderType, OrderStatus, OrderTypes, Topics, WalletAccount, GlobalSetting } from "../conf/Config";
import WebSocketClient from "../modules/WebSocketClient";
import { request } from "../utils/request";
import Selector from "../components/control/Selector";
import { OrderTypeSelector, NumberSelect, LoadingDialog, FailedDialog, CoinIcon, BalanceLabel, SymbolSelectView, OrderListView, tradingOrderReducer, OrderDetailView } from "../components/CommonComponents";
import Button from "../components/control/Button";
import { Events, JSEvent } from "../utils/JSEvent";
import ErrorCode from "../modules/Error"
import TabMenu from "../components/TabMenu";
import BigNumber from "bignumber.js";
import { LongTimeToDateStr, LongTimeToTimeStr } from "../utils/Utils";
import { CheckCircleIcon, ViewGridIcon } from "@heroicons/react/solid";
import BaseView from "../components/BaseViewComponent";

export default class TradeView extends BaseView {
    constructor(props) {
        super(props);
        //this.initState({test:111,test2:222})
    }

    render() {
        let { method, symbol } = this.props;
        if (method == null) {
            method = "buy";
        }
        if (symbol == null) {
            symbol = DataCenter.symbol.exchangePairs[0];
        }

        return (
            <div className="flex flex-col w-full h-full bg-gray-100">
                <ViewTitle method={method} symbol={symbol}
                    addView={(view, popFrom, onViewClosed, onViewAction, params) =>
                        this.addView(view, popFrom, onViewClosed, onViewAction, params)} />
                <div className="flex flex-col w-full flex-1 rounded-t-2xl bg-white">
                    <div className="flex flex-row w-full">
                        <PlatePanel symbol={symbol} />
                        <TradePanel symbol={symbol} method={method} />
                    </div>
                    <OrderPanel symbol={symbol} addView={(view, popFrom, onViewClosed, onViewAction, params) =>
                        this.addView(view, popFrom, onViewClosed, onViewAction, params)} />
                </div>
                {this.state.views}
            </div>
        )
    }
}


/**
 * 交易面板Title
 */
function ViewTitle({ method, symbol, addView }) {
    const [tradeMethod, setTradeMethod] = useState(method);
    const [symbolSpec, setSymbolSpec] = useState(symbol);
    const [updatePercent, setUpdatePercent] = useState(false);
    const [symbolViewShow, setSymbolViewShow] = useState(false);

    useEffect(() => setTradeMethod(method),
        [method]
    )

    useEffect(() => setSymbolSpec(symbol),
        [symbol]
    )


    useEffect(() => {
        init();
        return () => {
            unmount();
        }
    }, []);

    const onDataUpdated = name => {
        if (name == 'thumb') {
            setUpdatePercent(true);
        }
    }

    const init = () => {
        JSEvent.on(Events.DataCenter.DATA_UPDATED, onDataUpdated);
    }

    const unmount = () => {
        JSEvent.remove(Events.DataCenter.DATA_UPDATED, onDataUpdated);
    }

    const onViewAction = action => {
        if (action.name == "click") {
            JSEvent.emit(Events.MainMenu.SwitchMenu, { menu: "trade", args: { method: "buy", symbol: action.value } });
        }
        if (action.closeView != null) action.closeView();
    }

    //const thumb = DataCenter.getCoinPairThumb(symbolSpec.id);

    // const { close, lastClose, open, high, low, volume, turnover } = thumb;
    // const cc = CurrentCurrency();
    let { priceChange, percentChange, percent, percentSign, currencyPrice } = DataCenter.getCoinPairCurrentState(symbolSpec);
    if (updatePercent) setUpdatePercent(false);

    return <div className=" h-12 flex justify-start items-end px-3 pb-1.5"
        onClick={() => {
            if (symbolViewShow == false) {
                addView(SymbolSelectView, "left", () => { setSymbolViewShow(false) }, onViewAction);
                setSymbolViewShow(true);
            }
        }}
    >
        <div className="h-full flex items-end pb-2 pr-2">
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="48px" height="48px" viewBox="0 0 32 32"
                style={{
                    display: "inline-block", width: "1em", height: "1em", strokeWidth: 0,
                    stroke: "currentcolor", fill: "currentcolor"
                }} xmlSpace="preserve">
                <path d="M28 18c0 1.102-0.898 2-2 2h-18.008v-4l-7.992 6 7.992 6v-4h18.008c3.309 0 6-2.695 6-6h-4zM6 12h18v4l8-6-8-6v4h-18c-3.309 0-6 2.688-6 6h4c0-1.102 0.898-2 2-2z"></path>
            </svg>
        </div>
        <div className="text-2xl font-semibold flex pr-2">{symbolSpec.baseCoin.name}/{symbolSpec.quoteCoin.name}</div>

        {
            percentChange == "up" ?
                <div className="flex text-price-up">{percentSign}{percent.toFixed(2)}%</div> :
                <div className="flex text-price-down" >{percentSign}{percent.toFixed(2)}%</div>
        }

    </div>
}

/**
 * 交易面板盘口数据
 */
function PlatePanel({ symbol }) {
    const [currPriceStepIdx, setCurrPriceStepIdx] = useState(0);
    const [plateInfo, setPlateInfo] = useState(null);

    let listeningPlateTopic = "";

    useEffect(() => {
        init();
        return () => {
            unmount();
        }
    }, []);

    useEffect(() => {
        unmount();
        init();
    }, [symbol]);

    const onPlateTopic = (topic, msg) => {
        const body = JSON.parse(msg.body);
        setPlateInfo(body);
    }

    const { platePriceStep } = symbol;
    const priceStep1 = platePriceStep[currPriceStepIdx];
    let priceStepValues = [];
    platePriceStep.forEach(ps => {
        const v = Math.pow(10, -ps).toFixed(ps < 0 ? 0 : ps);
        priceStepValues.push(v);
    })

    const requestPlateInfo = (priceStep) => {
        if (priceStep == null) priceStep = priceStep1;
        request(API.market_symbolPlate(symbol.id, priceStep)).then(ret => {
            setPlateInfo(ret.retObject);

            if (listeningPlateTopic != "") {
                Connections.market.unsubscribe(listeningPlateTopic, onPlateTopic);
                listeningPlateTopic = ""
            }

            //订阅事件
            const topic = Topics.topicPlate(symbol.name, priceStep);
            Connections.market.subscribe(topic, onPlateTopic);
            listeningPlateTopic = topic;
        });
    }

    const init = () => {
        //获取盘口数据, 订阅盘口事件
        requestPlateInfo();
    }


    const unmount = () => {
        if (listeningPlateTopic != "") {
            Connections.market.unsubscribe(listeningPlateTopic, onPlateTopic);
            listeningPlateTopic = "";
        }
    }


    const thumb = DataCenter.getCoinPairThumb(symbol.id);

    const { close, lastClose, open, high, low, volume, turnover } = thumb;
    const cc = CurrentCurrency();
    let { priceChange, percentChange, percent, percentSign, currencyPrice } = DataCenter.getCoinPairCurrentState(symbol);


    //卖盘
    let sellPlate = [];
    let buyPlate = [];

    for (let i = 5; i >= 0; i--) {
        let price = '--';
        let amount = '--';

        if (plateInfo != null && plateInfo.sellPlate != null && plateInfo.sellPlate.length > i) {
            price = plateInfo.sellPlate[i].price;
            amount = plateInfo.sellPlate[i].volume;
        }

        sellPlate.push(
            <div className="flex w-full text-xs pt-1" key={i}>
                <div className="flex flex-1 text-price-down">{price}</div>
                <div className="flex flex-1 justify-end">{amount}</div>
            </div>
        );
    }


    for (let i = 0; i < 6; i++) {
        let price = '--';
        let amount = '--';

        if (plateInfo != null && plateInfo.sellPlate != null && plateInfo.buyPlate.length > i) {
            price = plateInfo.buyPlate[i].price;
            amount = plateInfo.buyPlate[i].volume;
        }

        buyPlate.push(
            <div className="flex w-full text-xs pt-1" key={i}>
                <div className="flex flex-1 text-price-up">{price}</div>
                <div className="flex flex-1 justify-end">{amount}</div>
            </div>
        );
    }

    return <div className="flex flex-col w-5/12 pl-3 pt-3 pr-2">
        <div className="flex w-full text-gray-400 text-xs">
            <div className="flex flex-1 flex-col">
                <div className="flex">价格</div>
                <div className="flex">({symbol.quoteCoin.name})</div>
            </div>
            <div className="flex flex-1 flex-col justify-end">
                <div className="flex justify-end">数量</div>
                <div className="flex justify-end">({symbol.baseCoin.name})</div>
            </div>
        </div>
        {sellPlate}
        <div className="flex flex-col w-full justify-center items-center py-1">
            {
                priceChange == "up" ?
                    <div className=" text-xl flex font-semibold text-price-up">{close.toFixed(symbol.quoteCoinDecimal)}</div> :
                    <div className=" text-xl flex font-semibold text-price-down">{close.toFixed(symbol.quoteCoinDecimal)}</div>
            }
            <div>≈{cc.symbol}{currencyPrice.toFixed(cc.decimals)}</div>
        </div>
        {buyPlate}
        <div className="flex mt-1 p-1 bg-gray-100 rounded-lg">
            <Selector
                keys={platePriceStep}
                values={priceStepValues}
                select={currPriceStepIdx}
                onChange={e => {
                    setCurrPriceStepIdx(e.index);
                    requestPlateInfo(platePriceStep[e.index]);
                    //if (onPlatePriceStepChanged != null) onPlatePriceStepChanged(e);
                }} />
        </div>
    </div>
}


/**
 * 交易面板交易交互区域
 */
function TradePanel({ symbol, method }) {
    const thumb = DataCenter.getCoinPairThumb(symbol.id);
    const { close, lastClose, open, high, low, volume, turnover } = thumb;

    const bq = DataCenter.walletBalance(WalletAccount.TradeAccount, symbol.quoteCoin.id, false).toString();
    const bb = DataCenter.walletBalance(WalletAccount.TradeAccount, symbol.baseCoin.id, false).toString();

    const [quoteBalance, setQuoteBalance] = useState(bq);
    const [baseBalance, setBaseBalance] = useState(bb);
    const [buyOrSell, setBuyOrSell] = useState(method);
    const [orderType, setOrderType] = useState(OrderTypes[0]);
    const [orderPrice, setOrderPrice] = useState(close.toFixed(symbol.quoteCoinDecimal));
    const [orderAmount, setOrderAmount] = useState("");
    const [orderTotalPrice, setOrderTotalPrice] = useState("");
    const [errorTip, setErrorTip] = useState("");
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(false);
    const [failedMsg, setFailedMsg] = useState(null);
    const [showError, setShowError] = useState(false);

    useEffect(() => {
        init();
        return () => {
            unmount();
        }
    }, []);

    useEffect(() => {
        const bq = DataCenter.walletBalance(WalletAccount.TradeAccount, symbol.quoteCoin.id, false).toString();
        const bb = DataCenter.walletBalance(WalletAccount.TradeAccount, symbol.baseCoin.id, false).toString();
        setQuoteBalance(bq);
        setBaseBalance(bb);

        setOrderPrice(close.toFixed(symbol.quoteCoinDecimal));
        setOrderAmount("");
        setOrderTotalPrice("");
        setErrorTip("");

    }, [symbol]);

    const onDataUpdated = dataName => {
        const bq = DataCenter.walletBalance(WalletAccount.TradeAccount, symbol.quoteCoin.id, false).toString();
        const bb = DataCenter.walletBalance(WalletAccount.TradeAccount, symbol.baseCoin.id, false).toString();
        setQuoteBalance(bq);
        setBaseBalance(bb);
    }

    const init = () => {
        JSEvent.on(Events.DataCenter.DATA_UPDATED, onDataUpdated);
    }
    const unmount = () => {
        JSEvent.remove(Events.DataCenter.DATA_UPDATED, onDataUpdated);
    }

    const onTopBtnClicked = btn => {
        setBuyOrSell(btn);
        setOrderPrice(close.toFixed(symbol.quoteCoinDecimal));
        setOrderAmount("");
        setOrderTotalPrice("");
        setErrorTip("");
    }

    const onDealBtnClicked = btn => {
        if (order != null) {
            setLoading(true);
            if (orderType.id == 1) {
                //市价单
                //获取当前实时价格
                const { close } = DataCenter.getCoinPairThumb(symbol.id);
                order.price = close;
            }
            request(API.exchange_placeOrder(order)).then(ret => {
                if (ret.error) {
                    //出错了
                    const msg = ErrorCode.msg(ret.code);
                    setFailedMsg(msg);
                    setShowError(true);
                    setTimeout(() => {
                        setShowError(false);
                    }, 2000);
                }
                //  else {
                //     JSEvent.emit(Events.Trade.ORDER_PLACED, ret.retObject);
                // }
                setLoading(false);
            })
        }
    }

    let topButton = <>
        <div className="flex flex-1 items-center justify-center h-10 rounded-l-md text-white bg-price-up"
            onClick={e => onTopBtnClicked("buy")}
        >买入</div>
        <div className="flex flex-1 items-center justify-center h-10 rounded-r-md text-gray-400 bg-gray-100"
            onClick={e => onTopBtnClicked("sell")}
        >卖出</div>
    </>

    if (buyOrSell == "sell") {
        topButton = <>
            <div className="flex flex-1 items-center justify-center h-10 rounded-l-md text-gray-400 bg-gray-100"
                onClick={e => onTopBtnClicked("buy")}
            >买入</div>
            <div className="flex flex-1 items-center justify-center h-10 rounded-r-md text-white bg-price-down"
                onClick={e => onTopBtnClicked("sell")}
            >卖出</div>
        </>;
    }


    let dealButton = <Button
        type="buy" className="flex flex-1 h-10"
        name={`买入 ${symbol.baseCoin.name}`}
        onClicked={e => onDealBtnClicked("buy")}
    />

    if (buyOrSell == "sell") {
        dealButton = <Button
            type="sell" className="flex flex-1 h-10"
            name={`卖出 ${symbol.baseCoin.name}`}
            onClicked={e => onDealBtnClicked("sell")}
        />
    }

    let countPanel = orderType.id == 0 ? <>
        <NumberSelect initValue={orderPrice}
            placeholder={`价格(${symbol.quoteCoin.name})`}
            decimals={symbol.quoteCoinDecimal} onValueChange={v => {
                onOrderPriceChanged(parseFloat(v));
            }} />
        <div className="h-2"></div>
        <NumberSelect initValue={orderAmount} placeholder={`数量(${symbol.baseCoin.name})`} decimals={symbol.baseCoinDecimal} onValueChange={v => {
            onOrderAmountChanged(parseFloat(v));
        }} />
        <div className="h-2"></div>
        <input type="number" className="flex w-full h-12 items-center justify-center font-semibold bg-gray-100 text-center outline-none"
            placeholder={`成交金额(${symbol.quoteCoin.name})`}
            value={orderTotalPrice}
            onKeyDown={e => { if (e.key == "Enter") e.target.blur() }}
            onBlur={e => {
                onOrderTotalPriceChanged((e.target.value));
            }}
            onChange={
                e => { setOrderTotalPrice(e.target.value); }
            }
        />
    </> : <>
        <div className="flex items-center justify-center h-12 bg-gray-200 text-gray-400 font-semibold">市价</div>
        <div className="h-2"></div>
        <NumberSelect initValue={orderAmount} placeholder={`数量(${symbol.baseCoin.name})`} decimals={symbol.baseCoinDecimal} onValueChange={v => {
            onOrderAmountChanged(parseFloat(v));
        }} />
    </>

    const onOrderPriceChanged = (price) => {
        setOrderPrice(price);
        if (price != 0 && orderAmount != 0) {
            setOrderTotalPrice((price * orderAmount).toFixed(symbol.quoteCoinDecimal));
        }
        calcOrder(price, orderAmount, orderTotalPrice, orderType);
    }

    const onOrderAmountChanged = (amount) => {
        setOrderAmount(amount);
        let totalPrice = (orderPrice * amount).toFixed(symbol.quoteCoinDecimal);
        if (amount != 0 && orderPrice != 0) {
            setOrderTotalPrice(totalPrice);
        } else {
            setOrderTotalPrice("");
        }
        calcOrder(orderPrice, amount, totalPrice, orderType);
    }

    const onOrderTotalPriceChanged = (total) => {
        let amount = 0;
        if (total > 0 && orderPrice > 0) {
            amount = total / orderPrice;
        }
        amount = amount.toFixed(symbol.baseCoinDecimal);
        total = (amount * orderPrice).toFixed(symbol.quoteCoinDecimal);
        setOrderTotalPrice(total);
        setOrderAmount(amount);
        calcOrder(orderPrice, orderAmount, total, orderType);
    }

    const calcOrder = (orderPrice, orderAmount, total, orderType) => {
        if (orderPrice > 0 && orderAmount > 0) {

            const limit = buyOrSell == "buy" ? quoteBalance : baseBalance;
            const amount = buyOrSell == "buy" ? total : orderAmount;
            if (amount > limit && orderType.id == 0) {
                setErrorTip("账户余额不足")
                setOrder(null);
            } else {
                setErrorTip("");

                if (orderType.id == 1) {
                    //市价单
                    // if (buyOrSell == "buy") {
                    //     orderPrice = (orderPrice * 1.1).toFixed(symbol.quoteCoinDecimal);
                    // } else {
                    //     orderPrice = (orderPrice * 0.9).toFixed(symbol.quoteCoinDecimal);
                    // }
                    //改到onDealBtnClicked中处理了
                }
                const order = {
                    account: DataCenter.accountId,
                    type: orderType.method,
                    action: buyOrSell == "buy" ? "BID" : "ASK",
                    symbolId: symbol.id,
                    price: orderPrice,
                    amount: orderAmount
                }
                setOrder(order);
            }
        } else {
            setOrder(null);
        }
    }


    return <div className="flex flex-col flex-1  h-full pl-2 pt-3 pr-3">
        <div className="flex w-full">
            {topButton}
        </div>
        <div className="w-full mt-3 pb-1 rounded-md bg-gray-100">
            <OrderTypeSelector onChange={e => {
                setOrderType(e);
                calcOrder(orderPrice, orderAmount, orderTotalPrice, e);
            }} />
        </div>
        <div className="h-2"></div>
        {countPanel}
        <div className="text-m text-red-500">{errorTip}</div>
        <div className="flex w-full">
            <div className="flex text-m text-gray-400">可用</div>
            {
                buyOrSell == "buy" ?
                    <div className="flex flex-1 text-m justify-end">{quoteBalance} {symbol.quoteCoin.name}</div> :
                    <div className="flex flex-1 text-m justify-end">{baseBalance} {symbol.baseCoin.name}</div>
            }
        </div>

        <div className="flex w-full flex-1 items-end">
            {dealButton}
        </div>
        <LoadingDialog show={loading} />
        <FailedDialog show={showError} text={failedMsg} />
    </div>
}


/**
 * 交易面板盘下方订单区域
 */
function OrderPanel({ symbol, addView }) {
    const [currOrder, currOrderDispatch] = useReducer(tradingOrderReducer, []);

    //const [currOrder, setCurrOrder] = useState([]);
    const [currType, setCurrType] = useState(0);
    const [hideOtherSymbol, setHideOtherSymbol] = useState(GlobalSetting.Setting.HideOtherSymbol);
    const [loading, setLoading] = useState(false);
    const [failedMsg, setFailedMsg] = useState(null);
    const [showError, setShowError] = useState(false);
    const [orderViewShow, setOrderViewShow] = useState(false);
    const [orderDetailShow, setOrderDetailShow] = useState(false);

    useEffect(() => {
        init();
        return () => unmount();
    }, [])

    useEffect(() => {
        request(API.exchange_tradingOrders(DataCenter.accountId, hideOtherSymbol ? symbol.id : -1)).then(ret => {
            updateTab(ret.retObject.length);
            currOrderDispatch({ type: "set", value: ret.retObject });
        })
    }, [hideOtherSymbol, symbol])

    const onOrderPlaced = order => {
        //setCurrOrder([order, ...currOrder]);
        currOrderDispatch({ type: "place", value: order });
    }

    const onOrderCanceled = order => {
        currOrderDispatch({ type: "cancel", value: order });
    }

    const onOrderUpdated = order => {
        currOrderDispatch({ type: "update", value: order });
    }

    const onTabItemChanged = (type, item) => {
        setCurrType(type);
    }

    const updateTab = (orderCount) => {
        const tabName = `当前委托(${orderCount})`;
        orderTabArr[0].name = tabName;
    }

    const init = () => {
        request(API.exchange_tradingOrders(DataCenter.accountId, hideOtherSymbol ? symbol.id : -1)).then(ret => {
            updateTab(ret.retObject.length);
            currOrderDispatch({ type: "set", value: ret.retObject });
        });

        //监听订单消息
        JSEvent.on(Events.Trade.ORDER_PLACED, onOrderPlaced);
        JSEvent.on(Events.Trade.ORDER_CANCELED, onOrderCanceled);
        JSEvent.on(Events.Trade.ORDER_UPDATED, onOrderUpdated);

    }
    const unmount = () => {
        JSEvent.remove(Events.Trade.ORDER_PLACED, onOrderPlaced);
        JSEvent.remove(Events.Trade.ORDER_CANCELED, onOrderCanceled);
        JSEvent.remove(Events.Trade.ORDER_UPDATED, onOrderUpdated);
    }

    const toggleSymbol = () => {
        const v = !hideOtherSymbol;
        setHideOtherSymbol(v);
        GlobalSetting.set("HideOtherSymbol", v);
    }

    const requestCancelOrder = (order) => {
        setLoading(true);
        request(API.exchange_cancelOrder({
            account: DataCenter.accountId,
            orderId: order == null ? -1 : order.id,
            symbolId: order == null ? (hideOtherSymbol ? symbol.id : -1) : order.symbolId
        })).then(ret => {
            setLoading(false);
            if (ret.error) {
                const msg = ErrorCode.msg(ret.code);
                setFailedMsg(msg);
                setShowError(true);
                setTimeout(() => {
                    setShowError(false);
                }, 2000);
            }
            // else {
            //     currOrderDispatch({ type: "cancel", value: ret.retObject });
            // }
        });
    }

    const orderPanel = (order) => {
        const pairSpec = DataCenter.getCoinPair(order.symbolId);
        const ot = GetOrderType(order.orderType);
        const price = BigNumber(order.price).toFixed(pairSpec.quoteCoinDecimal);
        const count = BigNumber(order.amount).toFixed(pairSpec.baseCoinDecimal);
        const tradedCount = BigNumber(order.tradeAmount).toFixed(pairSpec.baseCoinDecimal);

        return <div key={order.id} className="flex flex-row w-full px-4 py-1 text-m">
            <div className="flex flex-col w-[90px] justify-start items-center">
                {
                    order.orderAction == 1 ?
                        <div className="flex text-price-up text-m">{ot.short}/买入</div> :
                        <div className="flex text-price-down text-m">{ot.short}/卖出</div>
                }
                {
                    order.orderAction == 1 ?
                        <div className="text-price-up">{(tradedCount / count * 100).toFixed(0)}%</div> :
                        <div className="text-price-down">{(tradedCount / count * 100).toFixed(0)}%</div>
                }

            </div>
            <div className="flex flex-col flex-1 justify-start items-start pl-2">
                <div className="flex font-semibold">{pairSpec.baseCoin.name}/{pairSpec.quoteCoin.name}</div>
                <div className="flex flex-row pt-1">
                    <div className="flex text-gray-400">数量</div>
                    <div className="flex flex-1 pl-5">{tradedCount}/{count}</div>
                </div>
                <div className="flex flex-row">
                    <div className="flex text-gray-400">价格</div>
                    <div className="flex flex-1 pl-5">{price}</div>
                </div>
            </div>
            <div className="flex flex-col items-end">
                <div className="flex text-gray-400 text-m">{LongTimeToDateStr(order.createTime)}</div>
                <div className="flex text-gray-400 text-m">{LongTimeToTimeStr(order.createTime)}</div>
                <div className="flex pt-3"><Button onClicked={() => requestCancelOrder(order)} type="primary" name="撤单" widthStyle="w-24" /></div>
            </div>
        </div>
    }

    let panel = <div></div>
    if (currType == 0) {
        let items = [];
        currOrder.forEach(o => {
            items.push(orderPanel(o))
            items.push(<div key={10000000 + o.id} className="w-full px-4 py-4"><div className="w-full h-[1px] bg-gray-100"></div></div>)
        });
        panel = <>
            <div className="flex w-full px-4 py-1 items-center">
                <div className="flex w-full items-center" onClick={e => { toggleSymbol() }}>
                    {
                        hideOtherSymbol ?
                            <div className="flex w-5 h-5 text-price-up"><CheckCircleIcon className="w-5 h-5" /></div> :
                            <div className="flex w-5 h-5 text-gray-400"><CheckCircleIcon className="w-5 h-5" /></div>
                    }
                    {
                        hideOtherSymbol ?
                            <div className="flex text-m pl-3 ">隐藏其他交易对</div> :
                            <div className="flex text-m pl-3 text-gray-400">隐藏其他交易对</div>
                    }
                </div>
                <div className="flex flex-1 justify-end text-m"><Button onClicked={() => requestCancelOrder()} type="primary" name="撤销全部" widthStyle="w-24"></Button></div>
            </div>
            <div className="w-full px-4 py-1"><div className="w-full h-[1px] bg-gray-100"></div></div>
            {items}
        </>
    } else {
        const bq = DataCenter.walletBalance(WalletAccount.TradeAccount, symbol.quoteCoin.id, false);
        const bb = DataCenter.walletBalance(WalletAccount.TradeAccount, symbol.baseCoin.id, false);

        const currency = CurrentCurrency();

        const prize = DataCenter.getCoinQuotePrice(symbol.baseCoin.id, symbol.quoteCoin.id, currency.name).toNumber();
        const qPrize = DataCenter.getQuotePrice(symbol.quoteCoin.id, currency.name).toNumber();

        panel = <>
            <div className="flex flex-col w-full px-4 py-1 items-start text-gray-400">
                <div className="text-m ">当前币对资产</div>
                <div className="flex flex-row w-full pt-2">
                    <CoinIcon coin={symbol.baseCoin} className="mt-1 w-[26px] h-[26px]" />
                    <div className="flex flex-col px-2">
                        <div className="flex font-semibold text-black text-m">{symbol.baseCoin.name}</div>
                        <div className="flex text-gray-400 text-xs">{symbol.baseCoin.fullName}</div>
                    </div>
                    <div className="flex flex-col flex-1 items-end">
                        <div className="flex font-semibold text-black text-m">
                            <BalanceLabel className='text-m'
                                balance={bb} decimals={symbol.baseCoin.showDecimals} />
                        </div>
                        <div className="flex text-gray-400 text-xs">
                            <BalanceLabel className='text-m'
                                balance={bb} decimals={symbol.baseCoin.showDecimals} show={1}
                                exchangeRate={prize} coinSymbol={currency.symbol} /></div>
                    </div>
                </div>
                <div className="flex flex-row w-full pt-2">
                    <CoinIcon coin={symbol.quoteCoin} className="mt-1 w-[26px] h-[26px]" />
                    <div className="flex flex-col px-2">
                        <div className="flex font-semibold text-black text-m">{symbol.quoteCoin.name}</div>
                        <div className="flex text-gray-400 text-xs">{symbol.quoteCoin.fullName}</div>
                    </div>
                    <div className="flex flex-col flex-1 items-end">
                        <div className="flex font-semibold text-black text-m">
                            <BalanceLabel className='text-m' balance={bq} decimals={symbol.quoteCoin.showDecimals} />
                        </div>
                        <div className="flex text-gray-400 text-xs">
                            <BalanceLabel className='text-m'
                                balance={bq} decimals={currency.decimals} show={1}
                                exchangeRate={qPrize} coinSymbol={currency.symbol} /></div>
                    </div>
                </div>
            </div>
        </>
    }

    const orderTabArr = [{ type: 0, name: `当前委托(${currOrder.length})` },
    { type: 1, name: <div className="px-4">资产</div> }];

    const onViewAction = action => {
        if (action.name == "click") {
            //显示detail窗口
            if (!orderDetailShow) {
                addView(OrderDetailView, "right", () => { setOrderDetailShow(false) }, action => { }, { order: action.value });
                setOrderDetailShow(true);
            }
        }
    }

    return <div className="flex flex-col flex-1">
        <div className="flex w-full">
            <TabMenu tabItems={orderTabArr} onItemChanged={(type, item) => onTabItemChanged(type, item)} />
            <div className="flex flex-1 justify-end items-center pr-4">
                <ViewGridIcon className="w-8 h-8" onClick={() => {
                    if (orderViewShow == false) {
                        addView(OrderListView, "right", () => { setOrderViewShow(false) }, onViewAction, { symbol: symbol });
                        setOrderViewShow(true);
                    }
                }} />详情</div>
        </div>
        <div className="flex w-full h-[1px] bg-gray-100"></div>
        <div className="flex flex-col w-full flex-1">
            <div className="flex flex-col w-full flex-1 overflow-y-scroll basis-0 mt-3">
                <div className="flex flex-col w-full">
                    <div className="flex w-full flex-col">
                        {panel}
                    </div>
                </div>
            </div>
        </div>
        <LoadingDialog show={loading} />
        <FailedDialog show={showError} text={failedMsg} />
    </div>
}
